import api from "@/config/api"
import { withLoading } from "@/store/helpers"

export default {
  namespaced: true,
  state: () => ({
    sessions: [],
    loading: false,
  }),
  mutations: {
    setSessions(state, payload) {
      state.sessions = payload
    },
    setLoading(state, loading) {
      state.loading = loading
    },
  },
  actions: {
    async fetchSessions(context) {
      return withLoading(async () => {
        const response = await api.get("/sessions")
        context.commit("setSessions", response.data)
        return response.data
      }, context)
    },

    async revokeSession(context, id) {
      return withLoading(async () => {
        await api.delete(`/sessions/${id}`)
        const response = await api.get("/sessions")
        context.commit("setSessions", response.data)
      }, context)
    },

    async revokeOthers(context) {
      return withLoading(async () => {
        await api.delete("/sessions/destroy_others")
        const response = await api.get("/sessions")
        context.commit("setSessions", response.data)
      }, context)
    },
  },
}
